import { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

/**
 * Checks if a phone input value is empty or contains only a country code / prefix without subscriber digits.
 * E.g., "", "+61", "+213", "+91", "+1", "+44" will return true (considered empty/unfilled).
 * Numbers with subscriber digits like "+213555123456" or "+61412345678" will return false.
 */
export const isPhoneEmpty = (value) => {
  if (!value || typeof value !== 'string') return true;
  const trimmed = value.trim();
  if (trimmed === '' || trimmed === '+' || trimmed === '0') return true;

  try {
    const phoneNumber = parsePhoneNumber(trimmed);
    if (!phoneNumber || !phoneNumber.nationalNumber) {
      return true;
    }
  } catch (e) {
    const digitsOnly = trimmed.replace(/\D/g, '');
    if (digitsOnly.length <= 4) return true;
  }

  return false;
};

/**
 * Validates whether a phone number is either empty/only country code OR a valid phone number for its country.
 */
export const isPhoneEmptyOrValid = (value) => {
  if (isPhoneEmpty(value)) return true;
  return isValidPhoneNumber(value);
};

/**
 * Cleans phone number input, returning null if empty or only a country code.
 */
export const cleanPhoneNumber = (value) => {
  return !isPhoneEmpty(value) ? value : null;
};
